/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CustomerApiService } from './customer-api.service';

@Injectable({
  providedIn: 'root',
})
export class MaintenanceApiService {
  constructor(private api: CustomerApiService) {}

  /**
   * Returns the backend's maintenance status (message, background, etc.).
   */
  getStatus(): Observable<any> {
    return this.api.get('/v1/maintenance/status');
  }
}
